var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.p != null)?_c('div',[_c('div',{},[_c('span',[_vm._v("€")]),_vm._v(" "),_c('span',[_vm._v("\n            "+_vm._s(_vm.$root.currencyDisplaySimple(_vm.price))+"\n        ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }